<template>
    <div class="grade-management-box">
        <!-- 年级管理 -->
        <div class="nianji-box" v-if="!GradeManagementShow">
            <div class="fuzzy-matching-content">
                <el-button type="primary" @click="AddClick">新增组织</el-button>
                <el-button type="primary" @click="fanhui">返回</el-button>
            </div>
            <div class="fuzzy-matching-bottom">
                <el-table v-loading="loading" class="table-Style" :header-cell-style="{ background: '#F4F7FC', color: '#000', }"
                    ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                    @selection-change="handleSelectionChange">
                    <el-table-column prop="name" label="名称">
                    </el-table-column>
                    <el-table-column label="操作" min-width="100">
                        <template #default="scope">
                            <el-button type="text" size="small" class="searchBtn" @click="classManagement(scope.row)">三级组织管理</el-button>
                            <el-button type="text"  size="small" class="searchBtn" @click="xiugaiClick(scope.row)">修改</el-button>
                            <el-button type="text" class="shanchuBtn" size="small" @click="deleteClick(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="zuzhiblock-fenye">
                <el-pagination layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" />
            </div>
        </div>
        <el-dialog class="dia-log-box" :title="title" v-model="dialogVisible" width="30%"  :before-close="handleClose">
            <el-form ref="form" :model="form" :rules="rules">
                <el-form-item label="名称:" prop="schoolName" label-width="100px">
                    <el-input v-model="form.schoolName" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="备注:" label-width="100px">
                    <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.remark">
                    </el-input>
                </el-form-item>
                <div class="buttom-box">
                    <el-button type="primary" class="addForm" @click="onSubmit('form')">提交</el-button>
                    <el-button @click="handleClose">返回</el-button>
                </div>
            </el-form>

        </el-dialog>
        <GradeManagement v-if="GradeManagementShow" :ClassObj="ClassObj" @banjifanhui="banjifanhui"></GradeManagement>
    </div>
</template>

<script>
import { ElMessage } from 'element-plus'
import  GradeManagement  from '../class-management/index.vue'
import {schoolOrUserGradeInfo,addGrade,gradeList,updateaddGrade,teaddGradeDlete} from '@/assets/api/renyuan';
export default {
    components: {
        GradeManagement
    },
    props: ['gradeObj'],
    data() {
        return {
            tableData: [],
            pageInfo: {
                pageSize: "10",
                page: "1",
            },
            total: '',
            form: {
                remark: "",
                schoolName: ''
            },
            gradeId:'',
            ClassObj:{},
            rules: {
                schoolName: [
                    { required: true, message: '请输入名称', trigger: 'blur' },
                ],
            },
            title: '新增组织',
            dialogVisible: false,
            GradeManagementShow: false
        };
    },
    created() {
    },
    mounted() {
        this.gradeListliebiao()
        
    },
    methods: {
        //年级列表
        gradeListliebiao(){
            const params = {
                    page:this.pageInfo.page,
                    pageSize:this.pageInfo.pageSize
                    }
        gradeList(params,this.gradeObj.id).then((res)=> {
          this.tableData= res.data.data;
          this.total = res.data.data.total
        }).catch((err)=> {
          console.log(err,'年级列表');

        })

        },
        banjifanhui () {
            this.GradeManagementShow = false
            
        },  
        fanhui () {
            this.$emit('niajifanhui')
        },
        handleClose () {
            this.dialogVisible = false  
            this.gradeListliebiao()

        },
        onSubmit(formName) {
            // console.log(formName);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.title == '修改组织') {
                        console.log('修改', 8888);
                        this.addGradeXiugai()
                    } else if (this.title == '新增组织') {
                        this.addGradeXinzeng()
                    }
                } else {
                    console.log('校验不通过');
                }

            });
        },
        AddClick () {
            this.title = '新增组织'
            this.dialogVisible = true    
            console.log(8888888);
         
        },
        // 班级管理
        classManagement(item) {
            this.ClassObj = item
            this.GradeManagementShow = true
            // console.log(item, '班级管理');
        },
        // 修改详情
        xiugaiClick(item) {
            this.title = '修改组织'
            this.dialogVisible = true     
        schoolOrUserGradeInfo(item.id).then((res)=> {
            console.log(res);
            this.form.schoolName =res.data.data.name
            this.form.remark =res.data.data.description
            this.gradeId = res.data.data.id
        }).catch((err)=> {
            console.log(err,'xiugai');

        })
        },
        // 删除
        deleteClick(item){
            teaddGradeDlete(item.id).then((res)=> {
            this.$message({
                    type: 'success',
                    message: '删除成功'
                });
                this.gradeListliebiao()
            }).catch((err)=> {
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });

            })
        },
        // 修改接口
        addGradeXiugai(){
            const params = {
                id:this.gradeId,
                name:this.form.schoolName,
                remark:this.form.remark,
            }
            updateaddGrade(params).then((res)=> {
                this.$message({
                    type: 'success',
                    message:"修改成功"
                });
                this.handleClose()
            }).catch((err)=> {
                // console.log(err,'修改失败');
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });

            })

        },
        // 新增
        addGradeXinzeng(){
            const params = {
                id:this.gradeObj.id,
                name:this.form.schoolName,
                remark:this.form.remark,
            }
            addGrade(params).then((res)=> {
                // console.log(res,'新增成功');
                this.$message({
                    type: 'success',
                    message:"新增成功"
                });
                this.handleClose()
            }).catch((err)=> {
                // console.log(err,'新增失败');
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });

            })

        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageInfo.page = val
            this.gradeListliebiao()
        },

    },
};
</script>

<style scoped lang="scss">
.grade-management-box {
    height: 100%;
    background-color: #fff;
    border-radius: 15px;
    padding-top: 30px;

    .nianji-box {
        height: 100%;
    }

    .fuzzy-matching-content {
        height: 20px;
        line-height: 20px;
        margin-bottom: 30px;

        :deep() {
            .el-button {
                margin-left: 50px;
                font-size: 16px;
                // color: #1BC896;
                // background-color:#1BC896;
                height: 30px;

            }
        }
    }

    .fuzzy-matching-bottom {
        // position: absolute;
        height: 70%;
        overflow: auto;
        padding: 20px;
        .table-Style{
            // border-radius: 15px;
        }   
        .searchBtn{
            font-size: 15px;
            font-weight: 700;
            // color: #1BC896;

        }
        .shanchuBtn{
            font-size: 15px;
            font-weight: 700;
            color: red;
        }
        :deep() {
            .el-table th.el-table__cell>.cell {
                height: 30px;
                line-height: 30px;
                text-align: center;
                font-size: 16px;
                font-weight: 700;
            }

            .el-table td.el-table__cell div {
                text-align: center;
                height: 40px;
                line-height: 40px;
                border: 0;
                font-size: 16px;
            }

            .el-table:not(.el-table--border) .el-table__cell {
                border: 0;
            }

            .el-button--small {
                padding-left: 19px;
            }
        }

    }

    .zuzhiblock-fenye {
        margin-left: 1000px;
        margin-top: 15px;
    }

    :deep() {
        .el-dialog {

            .el-input--small .el-input__wrapper {
                height: 35px;
                line-height: 35px;
                text-align: center;
                width: 280px;
            }

            .el-input__inner {
                // width: 10px !important;
            }

            .buttom-box {
                // text-align: center;
                margin-left: 180px;
                .addForm{
                        // background-color: #1BC896;
                    }


            }

            .el-form-item--small {
                width: 70% !important;
            }
        }
    }
}
</style>
